module.exports = __webpack_public_path__ + "images/emoji/grinning.408d689341b9eff4f906.png";